import {
  DEFAULT_TIMELINE_PAGE_FUTURE_DESCRIPTION,
  DEFAULT_TIMELINE_PAGE_PRESENT_DESCRIPTION,
  FUTURE,
} from 'timeline/enums/constants';

/**
 * [getTimelinePageHeader] returns the title and subtitle for the page from breadcrumbs or uses default title/subtitle values
 * @param timePeriod {string} - current selected time period
 * @param breadcrumbYears {{name: string}[]} - timeline years from breadcrumbs
 * @param t {from useTranslation} - translation
 * @returns {{subtitle?: string, title: string}}
 */
export const getTimelinePageHeader = ({ timePeriod, breadcrumbYears, t }) => {
  // find year from breadcrumbs associated to currently selected timePeriod
  const currentYear = breadcrumbYears?.find((breadcrumbYear) => breadcrumbYear.name === timePeriod);
  // return description as subtitle if it exists
  if (currentYear) {
    return {
      title: currentYear.name,
      description: currentYear.description || DEFAULT_TIMELINE_PAGE_PRESENT_DESCRIPTION,
    };
  }

  return {
    title:
      timePeriod === FUTURE
        ? t('timeline.futureHeaderTitle', 'Timeline: Upcoming Releases')
        : t('timeline.headerTitle', 'Timeline: Sneaker Releases'),
    description:
      timePeriod === FUTURE
        ? DEFAULT_TIMELINE_PAGE_FUTURE_DESCRIPTION
        : DEFAULT_TIMELINE_PAGE_PRESENT_DESCRIPTION,
  };
};
